import React, { useState, useEffect } from "react";
import EntrepenantForm from "../Forms/EntrepenantForm";
import PmeForm from "../Forms/PmeForm";
import StartupForm from "../Forms/StartupForm";

const Step4Profil = ({ step4Profil, step4ProfilData, forms, formsData }) => {
  const [choice, setChoice] = useState(1);
  const [profilForm, setProfilForm] = useState({
    category: "",
    isValid: false,
    ...step4Profil,
  });

  const [pmeValid, setPmeValid] = useState(false);
  const [startupValid, setStartupValid] = useState(false);
  const [entreValid, setEntreValid] = useState(false);

  const [entrepenantForms, setEntrepenantForms] = useState({});

  const [pmeForms, setPmeForms] = useState({});

  const [startUpForms, setStartUpForms] = useState({});

  function entrepenantFormsData(data) {
    formsData({ ...forms, ...data });
    if(data.address && data.sector){
      setEntreValid(true)
      console.log({ ...forms, ...data })
    }
    else{
      setEntreValid(false)
    }
    setEntrepenantForms(data);
  }

  function pmeFormsData(data) {
    formsData({ ...forms, ...data });
    if(data.address && data.sector && data.denomination
      && data.entreprise_email && data.entreprise_phone
      && data.ncc && data.nrc){
        console.log({ ...forms, ...data })
        setPmeValid(true)
    }
    else{
      setPmeValid(false)
    }
    setPmeForms(data);
  }

  function startUpFormsData(data) {
    formsData({ ...forms, ...data });
    if(data.address && data.sector && data.denomination
      && data.entreprise_email && data.entreprise_phone
      && data.ncc && data.nrc && data.website){
        console.log(data)
        setStartupValid(true)
    }
    else{
      setStartupValid(false)
    }
    setStartUpForms(data);
  }

  const handleChange = (e) => {
    setProfilForm({
      ...profilForm,
      [e.target.name]: e.target.value,
    });
    if ([e.target.value] == "Porteur de projet") {
      setChoice(1);
    } else if ([e.target.value] == "Entreprenant") {
      setChoice(2);
    } else if ([e.target.value] == "PME") {
      setChoice(3);
    } else if ([e.target.value] == "Startup") {
      setChoice(4);
    }
  };

  useEffect(() => {
    step4ProfilData(profilForm);
    if(profilForm.category =="Porteur de projet"){
      step4ProfilData({...profilForm, isValid: true});
    }
    else{
      if(profilForm.category =="PME"){
        step4ProfilData({...profilForm, isValid: pmeValid});
        console.log(profilForm.category, pmeValid)
      }
      if(profilForm.category =="Startup"){
        step4ProfilData({...profilForm, isValid: startupValid});
      }
      if(profilForm.category =="Entreprenant"){
        step4ProfilData({...profilForm, isValid: entreValid});
      }else{
        step4ProfilData({...profilForm, isValid: true});
        //you have to correct later
      }
      console.log(profilForm.category, pmeValid)
    }
  }, [profilForm, pmeValid, startupValid, entreValid]);

  return (
    <>
      <form>
        <div className="col">
          <p className="text-start">Êtes vous ?</p>
          <div className="checker gap-3">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="category"
                value="Porteur de projet"
                onChange={handleChange}
                checked={
                  profilForm.category == "Porteur de projet" ? true : false
                }
                id="porteur_de_projet"
                required
              />
              <label class="form-check-label" for="porteur_de_projet">
                Porteur de projet
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="category"
                value="Entreprenant"
                onChange={handleChange}
                checked={profilForm.category == "Entreprenant" ? true : false}
                id="entreprenant"
                required
              />
              <label class="form-check-label" for="entreprenant">
                Entreprenant
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="category"
                value="PME"
                checked={profilForm.category == "PME" ? true : false}
                onChange={handleChange}
                id="pme"
                required
              />
              <label class="form-check-label" for="pme">
                PME / Startup
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="category"
                value="Startup"
                checked={profilForm.category == "Startup" ? true : false}
                onChange={handleChange}
                id="startup"
                required
              />
              <label class="form-check-label" for="startup">
                Groupement
              </label>
            </div>
          </div>
          {choice == 2 && (
            <>
              <EntrepenantForm
                entrepenantForms={entrepenantForms}
                entrepenantFormsData={entrepenantFormsData}
              />
            </>
          )}
          {choice == 3 && (
            <>
              <PmeForm pmeForms={pmeForms} pmeFormsData={pmeFormsData} />
            </>
          )}
          {choice == 4 && (
            <>
              <StartupForm
                startUpForms={startUpForms}
                startUpFormsData={startUpFormsData}
              />
            </>
          )}
        </div>
      </form>
    </>
  );
};

export default Step4Profil;
